import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class InfoBox extends Div
{
    constructor(title: string, content: appendable, theme: string = "#a87603")
    {
        super();

        this.Style(`display: block; margin: 32px 0; text-align: center;`);

        this.Append(
            new Div().Style(`display: inline-block; padding: 16px; color: #222; text-align: left; border-left: 12px solid ${theme}`)
                .Append(
                    new Div().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme),
                    content,
                )
        );
    }
}
